import {
    CHANGE_USER_AT_LOGIN_PROPERTIES, DISPLAY_INFO_DIALOG_BOX,
    DISPLAY_REJECT_AUTH_DIALOG_BOX, RECEIVE_LOG_IN_RESPONSE, REQUEST_TO_LOGIN,
    LOGOUT,
    RECEIVE_TOBA, RECEIVE_ACCEPT_TOBA,
    DISPLAY_TOBA, RECEIVE_VERSION, FAILED_TO_RECEIVE_TOBA, REQUEST_TOBA, FAILED_TO_ACCEPT_TOBA, REQUEST_ACCEPT_TOBA,
    CHANGE_USER_STATE_SETTINGS, REQUEST_TOBA_MESSAGE, RECEIVE_TOBA_MESSAGE, RECEIVE_FAILURE_TOBA_MESSAGE
} from '../actions/index';
import {
    CLOSE_TOBA_REJECT_MODAL,
    GET_SESSION_EXPIRATION_DATE_SUCCESS,
    OPEN_TOBA_REJECT_MODAL,
    RECEIVE_BAD_REQUEST_GET_APPLICATION
} from "../actions";
import * as ActionTypes from "../actions";
import {extractSpecificElementOfArray} from "../helpers/functions";
import {convertCaseSubCaseTypeDTOsToSubCaseTypeState} from "../helpers/advanceDisbursments/advanceDisbursements";

const defaultState = {
    loggedInUser: {
        id: '',
        userName: "test",
        email: "",
        token: "",
        roles: ["Guest"],
        status: false,
        toba: false,
        agentId: null,
        solicitorId: null,
        solicitorGroupId: null,
    },
    loginFormData: {
        username: "",
        email: "",
        password: ""
    },
    infoDialogBoxAppear: false,
    rejectedAuthDialogBoxData: '',
    rejectedAuthDialogBox: false,
    loggingIn: false,
    toba: [],
    displayToba: true,
    version: "",
    fetchingPendingToba: false,
    failedToReceivePendingTobaMsg: '',
    acceptingToba: false,
    failedToAcceptToba: '',
    madeAttempts: 0,
    reCaptchaResponse: '',
    resetRecaptcha: false,
    tobaMessage: {},
    fetchingTobaMessage: false,
    tobaMessageFailure: '',
    isTobaRejectModalOpen: false,
    reCaptchaMessage: '',
    sessionExpirationDate: '',
    sendingForgotPassword: false,
    sendForgotPasswordSuccessMsg: '',
    sendForgotPasswordFailedMsg: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.SEND_FORGOT_PASSWORD:
            return {
                ...state,
                sendingForgotPassword: true,
                sendForgotPasswordSuccessMsg: defaultState.sendForgotPasswordSuccessMsg,
                sendForgotPasswordFailedMsg: defaultState.sendForgotPasswordFailedMsg,
            };
        case ActionTypes.SEND_FORGOT_PASSWORD_SUCCESS:
            let forgotMsg = '';
            try {
                forgotMsg = action.payload.body
            } catch (e) {
                forgotMsg = 'An email has been sent to you to reset your password';
            }
            return {
                ...state,
                sendingForgotPassword: false,
                sendForgotPasswordSuccessMsg: forgotMsg
            };
        case ActionTypes.SEND_FORGOT_PASSWORD_FAILED:
            let sendEmailErrorMsg = '';
            try {
                sendEmailErrorMsg = action.payload.response.body.message;
            } catch (e) {
                sendEmailErrorMsg = 'Failed to send email'
            }
            return {
                ...state,
                sendingForgotPassword: false,
                sendForgotPasswordFailedMsg: sendEmailErrorMsg
            };
        case GET_SESSION_EXPIRATION_DATE_SUCCESS:
            return {
                ...state,
                sessionExpirationDate: action.payload.body
            };
        case RECEIVE_BAD_REQUEST_GET_APPLICATION:
            let aFormErrorMessage = '';
            try {
                aFormErrorMessage = action.payload.response.body.message
            } catch (e) {
                aFormErrorMessage = 'Failed to get the application form'
            }
            return {
                ...state,
                loggedInUser: {
                    ...state.loggedInUser,
                    toba: aFormErrorMessage.includes('TOBA has been updated') ? false : defaultState.displayToba
                },
                displayToba: aFormErrorMessage.includes('TOBA has been updated') ? false : defaultState.displayToba
            };
        case OPEN_TOBA_REJECT_MODAL:
            return {
                ...state,
                isTobaRejectModalOpen: true
            };
        case CLOSE_TOBA_REJECT_MODAL:
            return {
                ...state,
                isTobaRejectModalOpen: false
            };
        case CHANGE_USER_STATE_SETTINGS:
            return {
                ...state,
                resetRecaptcha: action.payload.key === 'reCaptchaResponse' && action.payload.value !== '' ? false : state.resetRecaptcha,
                [action.payload.key]: action.payload.value
            };
        case CHANGE_USER_AT_LOGIN_PROPERTIES:
            if (action.payload.key === 'username') {
                return {
                    ...state,
                    loginFormData: {
                        ...state.loginFormData,
                        [action.payload.key]: action.payload.value,
                        email: action.payload.value
                    },
                    rejectedAuthDialogBox: false,
                };
            }
            return {
                ...state,
                loginFormData: {
                    ...state.loginFormData,
                    [action.payload.key]: action.payload.value,
                },
                rejectedAuthDialogBox: false,
            };
        case DISPLAY_INFO_DIALOG_BOX:
            return {
                ...state,
                infoDialogBoxAppear: !state.infoDialogBoxAppear
            };
        case DISPLAY_REJECT_AUTH_DIALOG_BOX:
            let error = '';
            try {
                if (!action.payload.status) {
                    error = 'Failed to login'
                } else {
                    error = action.payload.response.text
                }
            } catch (e) {
                error = 'Failed to login'
            }
            return {
                ...state,
                rejectedAuthDialogBoxData: error,
                rejectedAuthDialogBox: true,
                loggingIn: false,
                madeAttempts: state.madeAttempts + 1,
                resetRecaptcha: state.madeAttempts >= 3 ? true : false,
                loginFormData: {
                    ...state.loginFormData,
                    password: ''
                }
            };
        case REQUEST_TO_LOGIN:
            return {
                ...state,
                loggingIn: true
            };
        case RECEIVE_LOG_IN_RESPONSE:
            let loggenInUser = {};
            let subCasesAndSubIds=convertCaseSubCaseTypeDTOsToSubCaseTypeState({
                disbursementsCaseSubCaseTypeDtos:action.payload.body.allowedDisbursementsCaseSubCaseTypeDtos
            });
            try {
                loggenInUser = {
                    agentId: action.payload.body.agentId,
                    allowedDisbursementsCaseSubCaseTypeDtos: action.payload.body.allowedDisbursementsCaseSubCaseTypeDtos ? action.payload.body.allowedDisbursementsCaseSubCaseTypeDtos : [],
                    allowedDisbursementsCaseIdList: action.payload.body.allowedDisbursementsCaseSubCaseTypeDtos? action.payload.body.allowedDisbursementsCaseSubCaseTypeDtos.map(i =>i.id):[],
                    allowedDisbursementsSubCaseIdList:subCasesAndSubIds.adSubCaseTypes.map(i=> i.id),
                    allowedToCreateApplications: action.payload.body.allowedToCreateApplications ? action.payload.body.allowedToCreateApplications : false,
                    allowedToEditArticles: action.payload.body.allowedToEditArticles ? action.payload.body.allowedToEditArticles : null,
                    allowedToEditOtherApplications: action.payload.body.allowedToEditOtherApplications ? action.payload.body.allowedToEditOtherApplications : null,
                    allowedToEditPremiumSettings: action.payload.body.allowedToEditPremiumSettings ? action.payload.body.allowedToEditPremiumSettings : null,
                    allowedToEditReferralSettings: action.payload.body.allowedToEditReferralSettings ? action.payload.body.allowedToEditReferralSettings : null,
                    allowedToEditTobas: action.payload.body.allowedToEditTobas ? action.payload.body.allowedToEditTobas : null,
                    allowedToCreateInternalAlerts: action.payload.body.allowedToCreateInternalAlerts ? action.payload.body.allowedToCreateInternalAlerts : null,
                    allowedToSeeAllFirmApplications: action.payload.body.allowedToSeeAllFirmApplications ? action.payload.body.allowedToSeeAllFirmApplications : false,
                    email: action.payload.body.email ? action.payload.body.email : '',
                    forename: action.payload.body.forename ? action.payload.body.forename : '',
                    id: action.payload.body.id ? action.payload.body.id : null,
                    levelName: action.payload.body.levelName ? action.payload.body.levelName : null,
                    requiredWorkSource: action.payload.body.requiredWorkSource ? action.payload.body.requiredWorkSource : false,
                    roles: action.payload.body.roles,
                    selectedCaseTypes: action.payload.body.selectedCaseTypes ? action.payload.body.selectedCaseTypes : null,
                    selectedNotificationTypes: action.payload.body.selectedNotificationTypes ? action.payload.body.selectedNotificationTypes : null,
                    selectedStatuses: action.payload.body.selectedStatuses ? action.payload.body.selectedStatuses : null,
                    selectedUpdateQuestions: action.payload.body.selectedUpdateQuestions ? action.payload.body.selectedUpdateQuestions : null,
                    solicitorGroupAllowedToApplyForDisbursements: action.payload.body.solicitorGroupAllowedToApplyForDisbursements ? action.payload.body.solicitorGroupAllowedToApplyForDisbursements : null,
                    solicitorGroupId: action.payload.body.solicitorGroupId ? action.payload.body.solicitorGroupId : null,
                    solicitorId: action.payload.body.solicitorId ? action.payload.body.solicitorId : null,
                    solicitorUserAllowedToApplyForDisbursements: action.payload.body.solicitorUserAllowedToApplyForDisbursements ? action.payload.body.solicitorUserAllowedToApplyForDisbursements : null,
                    surname: action.payload.body.surname,
                    toba: action.payload.body.toba,
                    tokenValidUntil: action.payload.body.tokenValidUntil,
                    username: action.payload.body.username,
                }


            } catch (e) {
                loggenInUser = {...defaultState.loggedInUser}
            }
            return {
                ...state,
                loggedInUser: loggenInUser,
                loggingIn: false,
                rejectedAuthDialogBox: false,
                loginFormData: {...state.loginFormData, password: ''},
                madeAttempts: 0,
                resetRecaptcha: false
            };
        case RECEIVE_VERSION:
            return {
                ...state,
                version: action.payload,
            };
        case LOGOUT:
            return {
                ...defaultState
            };
        case REQUEST_TOBA:
            return {
                ...state,
                fetchingPendingToba: true
            };
        case RECEIVE_TOBA:
            return {
                ...state,
                toba: action.payload,
                fetchingPendingToba: false
            };
        case FAILED_TO_RECEIVE_TOBA:
            return {
                ...state,
                fetchingPendingToba: false,
                failedToReceivePendingTobaMsg: 'Failed to receive new available TOBA. Please try logging in again.',
                displayToba: false
            };
        case REQUEST_ACCEPT_TOBA:
            return {
                ...state,
                acceptingToba: true
            };
        case RECEIVE_ACCEPT_TOBA:
            return {
                ...state,
                loggedInUser: {...state.loggedInUser, toba: true},
                acceptingToba: false,
                isTobaRejectModalOpen: false,
                displayToba: false
            };
        case FAILED_TO_ACCEPT_TOBA:
            return {
                ...state,
                acceptingToba: false,
                failedToAcceptToba: 'Failed To accept Toba. Please try again later.',
                isTobaRejectModalOpen: false
            };
        case DISPLAY_TOBA:
            return {
                ...state,
                displayToba: false,
                isTobaRejectModalOpen: false
            };
        case REQUEST_TOBA_MESSAGE:
            return {
                ...state,
                fetchingTobaMessage: true,
                tobaMessageFailure: ''
            };
        case RECEIVE_TOBA_MESSAGE:
            return {
                ...state,
                fetchingTobaMessage: false,
                tobaMessage: action.payload
            };
        case RECEIVE_FAILURE_TOBA_MESSAGE:
            return {
                ...state,
                fetchingTobaMessage: false,
                tobaMessageFailure: action.payload
            };
        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                madeAttempts: defaultState.madeAttempts,
                reCaptchaResponse: defaultState.reCaptchaResponse,
                resetRecaptcha: false,
                reCaptchaMessage: defaultState.reCaptchaMessage,
                sendForgotPasswordSuccessMsg: defaultState.sendForgotPasswordSuccessMsg,
                sendForgotPasswordFailedMsg: defaultState.sendForgotPasswordFailedMsg
            };
        case 'persist/REHYDRATE':
            return {
                ...state,
                ...(action.payload ? action.payload.user : defaultState),
                madeAttempts: defaultState.madeAttempts,
                reCaptchaResponse: defaultState.reCaptchaResponse,
                resetRecaptcha: false,
                loginFormData: defaultState.loginFormData,
                rejectedAuthDialogBoxData: defaultState.rejectedAuthDialogBoxData,
                rejectedAuthDialogBox: defaultState.rejectedAuthDialogBox,
                loggingIn: defaultState.loggingIn,
            };
        default :
            return state
    }
}